export default __webpack_public_path__ + "static/1510-1bf1709c5ac1f62451a6d4966c5a0def.gif";